<template>
  <el-row class="editPanel">
    <el-col :span="24">
      <h3 :class="{closed: !panelOpen}">Authorization</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
      <transition name="panel">
        <div class="pea-panel .authorizations-panel" v-if="panelOpen">
        <el-table :data="authorizationData"
                  stripe v-loading="tableLoading"
          style="width: 100%">
          <el-table-column align="left" type="index"  width="100"
                           label="Order">
          </el-table-column>
          <el-table-column prop="roleDescription" align="left"
                           label="Role">
          </el-table-column>
          <el-table-column prop="authorizerName" align="left"
                           label="Person">
          </el-table-column>
          <el-table-column prop="approvalStatusName" align="left"
                          label="Status">
          </el-table-column>
          <!--<el-table-column prop="ruleDescription" style="word-wrap:normal"  align="left"
                          label="Reason">
          </el-table-column>-->
          <el-table-column prop="approverComment" style="word-wrap:normal" align="left"
                         label="Comment">
          </el-table-column>
          <el-table-column prop="approvalDate" style="word-wrap:normal" align="left"
                         label="Date">
          </el-table-column>
        </el-table>
        </div>
      </transition>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-authorization',
  props: {
    peaId:
    {
      default: 0
    },
    canEditPea: {
      default: false
    },
    isApprover: {
      default: false
    }
  },
  data () {
    return {
      authorizationData: [],
      panelOpen: true,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/getPEAAuthorizations/' + this.peaId
      this.$axios.get(call).then(response => {
        // for historical data, that does not have a PEARule set
        if (response.data.length === 0) {
          call = '/getPEAAuthorizationsNoRule/' + this.peaId
          this.$axios.get(call).then(response => {
            this.authorizationData = response.data
            this.getAuthDates(this.authorizationData)
            this.$emit('fetchComplete')
            this.tableLoading = false
          }).catch(reject => {
            this.tableLoading = false
            this.tableData = null
            helperMethods.showNotification(this.$parent, 'Error retrieving PEA Authorizations', 'No Rule: ' + reject.body, 'error', 30000)
          })
        } else {
          this.authorizationData = response.data
          this.getAuthDates(this.authorizationData)
          this.$emit('fetchComplete')
          this.tableLoading = false
        }
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        helperMethods.showNotification(this.$parent, 'Error retrieving PEA Authorizations', reject.body, 'error', 30000)
      })
    },
    getAuthDates (data) {
      for (var i in data) {
        data[i].approvalDate = helperMethods.formatPEAAuthorizationsDate(data[i].approvalDate)
      }
    },
    calculateIndex (index) {
      return ((this.currentPage * this.pageSize) - this.pageSize) + index + 1
    },
    startUp () {
      this.fetchData()
    }
  },
  mounted () {
    this.startUp()
  }
}
</script>

<style scoped>
  h4 {
  margin-bottom: 20px;
  }
  .authorizations-panel {
  padding-bottom: 30px;
  }
</style>
